module.exports = __webpack_public_path__ + "static/media/27.7e32ab78.jpg";